
import { Component, Ref, Vue } from 'vue-property-decorator'
import ModalProofreadQuestion from '@/components/templates/manage/ModalProofreadQuestion.vue'
import { StudyModel } from '@/models/StudyModel'

/**
 * 校正画面-正誤結果表示モーダル
 */
@Component({
  components: {
    ModalProofreadQuestion,
  },
})
export default class ModalProofreadResult extends Vue {
  /** 正誤結果モーダル */
  @Ref()
  private modalProofreadQuestion!: ModalProofreadQuestion

  /**
   * モーダルを開く
   *
   * @param question 設問情報
   * @param correctAnswers 正答(入力欄・許容解全ての二次元配列)
   * @param isCorrect 正誤結果
   */
  public show(question: StudyModel.Question, correctAnswers: string[][], isCorrect: boolean): void {
    this.modalProofreadQuestion.show(question, correctAnswers, isCorrect)
  }
}
